import { Carousel } from "react-responsive-carousel"
import styled from "styled-components"

export const Container = styled.div`
  background-color: #FCF8EF;
  padding: 80px 0;
  width: 100%;

  @media (max-width: 768px) {
    padding: 62px 32px;

    .slider-wrapper {
      margin-bottom: 32px;
    }
  }
`

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 38px;
`

export const Title = styled.h4`
  color: #00A687;
  font-family: Ubuntu;
  font-size: 32px;
  font-weight: 700;
  line-height: 36.77px;
`

export const CardContainer = styled.div`
  width: 100%;

  .carousel .slide img {
    width: auto !important;
  }

  .carousel .control-dots {
    margin-bottom: 0;
    .dot {
      background-color: transparent;
      border: 1px solid #00A687;
      box-shadow: none;
      border-radius: 50px;
      height: 8px;
      opacity: 1;
      width: 38px;

      &.selected,
      &:hover {
        background-color: #00A687;
      }
    }
  }
`

export const CarouselDesktop = styled(Carousel)`
  @media (max-width: 768px) {
    display: none;
  }
`

export const CarouselMobile = styled(Carousel)`
  @media (min-width: 767px) {
    display: none;
  }
`

export const CardWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 38px;
  margin-bottom: 54px;
`

export const Card = styled.div`
  border: 1px solid #4CC5B6;
  border-radius: 20px;
  display: flex;
  flex-direction: column;
  padding: 16px;
`